<script>
import youtubeHelpersMixin from '@/mixins/youtubeHelpersMixin.js'

export default {
  name: 'SlideShowSlide',
  mixins:[youtubeHelpersMixin],
  props: {
    slide: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clicked'],
  methods: {
    clickedImage() {
      if(this.readonly) {
        this.$emit('clicked', this.slide)
      }
      else {
        window.location.url = slide.upload.url
      }
    }
  }
}
</script>

<template>
  <img v-if="slide.type === 'upload' && slide.upload" class="object-cover cursor-pointer" alt="Slide" :src="slide.upload.url_small" @click="clickedImage">
  <iframe v-else-if="slide.type === 'url' && !readonly" :src="`//www.youtube.com/embed/${getYoutubeIdFromUrl(slide.url)}`" class="object-scale-down " width="100%" />
  <iframe v-else-if="slide.type === 'youtube' && !readonly" :src="`//www.youtube.com/embed/${getYoutubeIdFromUrl(slide.url)}`" class="object-scale-down " width="100%" />
  <div v-else-if="slide.type === 'youtube' && readonly && slide.thumbnail" class="video-thumbnail">
    <img :src="slide.thumbnail" class="object-scale-down cursor-pointer" width="100%" @click="$emit('clicked', slide)">
    <div class="play-button">
      &#9658;
    </div>
  </div>
  <iframe v-else-if="slide.type === 'embed'" :src="slide.url" class="object-scale-down " width="100%" />
  <div v-else>
    Unsupported content
  </div>
</template>

<style scoped>
.video-thumbnail {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.video-thumbnail img {

}

.play-button {
  font-family: Arial, sans-serif;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 48px;
  color: white;
  opacity: 0.8;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 20px 34px;
  pointer-events: none; /* Allow clicking through the button to the parent */
}
</style>
